module.exports = __webpack_public_path__ + "static/img/CALEB-WINDSOR.ed3a3d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CALEB-WINDSOR.jpg
// module id = pLhm
// module chunks = 0